import ko from "knockout";
import $ from "jquery";
import metaCache from "flow/utils/metaCache";
import register from "flow/knockout/register";
import { cleanHtml } from "flow/utils/cleanHtml";

register.registerKnockoutBinding("meta", {
    init: function (element, valueAccessor) {
        const potentialObservable = valueAccessor();

        const initialKey = ko.unwrap(potentialObservable);
        const initialValue = metaCache.translate(initialKey);
        const textNode = document.createTextNode(initialValue);
        element.insertBefore(textNode, element.firstChild);

        if (ko.isObservable(potentialObservable)) {
            const subscription = potentialObservable.subscribe(newKey => {
                const newValue = metaCache.translate(newKey);
                textNode.textContent = newValue;
            });

            ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
                subscription.dispose();
            });
        }

        return { controlsDescendantBindings: true };
    }
});

register.registerKnockoutBinding("metaHtml", {
    init() {
        return { controlsDescendantBindings: true };
    },
    update(element, valueAccessor) {
        const key = ko.unwrap(valueAccessor());
        if (key !== undefined) {
            const potentiallyUnsafeHtml = metaCache.lookup(key, key);
            const safeHtml = cleanHtml(potentiallyUnsafeHtml);
            ko.utils.setHtml(element, safeHtml);
        }
    }
});

register.registerKnockoutBinding("metaLabel", {
    update: function (element, valueAccessor) {
        const key = ko.utils.unwrapObservable(valueAccessor());
        if (key !== undefined) {
            $(element).attr("label", metaCache.lookup(key, key));
        }
    }
});

register.registerKnockoutBinding("metaTitle", {
    update: function (element, valueAccessor) {
        const key = ko.utils.unwrapObservable(valueAccessor());
        if (key !== undefined) {
            $(element).attr("title", metaCache.lookup(key, key));
        }
    }
});

register.registerKnockoutBinding("metaPlaceholder", {
    update: function (element, valueAccessor) {
        const key = ko.utils.unwrapObservable(valueAccessor());
        if (key !== undefined) {
            $(element).attr("placeholder", metaCache.lookup(key, key));
        }
    }
});

register.registerKnockoutBinding("metaAlt", {
    update: function (element, valueAccessor) {
        const key = ko.utils.unwrapObservable(valueAccessor());
        if (key !== undefined) {
            $(element).attr("alt", metaCache.lookup(key, key));
        }
    }
});
